<template>
  <div class="row w-100 ml-0">
    <course-item v-for="item in items" :key="item.id" :item="item" />
  </div>
</template>

<script>
import Item from './Item/index'

export default {
  props: {
    items: {
      required: true,
      type: Array
    }
  },
  components: {
    'course-item': Item
  }
}
</script>
